import {setInitialState} from '../../../utils/reducerOperations';

export const Default=()=>({
    dimensionListApi:setInitialState()
});